import React, { ReactNode } from 'react'

interface CardProps {
    children: ReactNode
    className?: string
    onClick?: () => void
    elevation?: 'none' | 'low' | 'medium' | 'high'
    border?: boolean
    rounded?: boolean
    padded?: boolean
    style?: React.CSSProperties
    testId?: string
}

export function Card(props: CardProps) {
    const {
        children,
        className = '',
        onClick,
        elevation = 'low',
        border = false,
        rounded = true,
        padded = true,
        style = {},
        testId = 'card',
    } = props

    const elevationClass = elevation !== 'none' ? `elevation-${elevation}` : ''
    const borderClass = border ? 'border' : ''
    const roundedClass = rounded ? 'rounded' : ''
    const paddedClass = padded ? 'padded' : ''
    const clickableClass = onClick ? 'clickable' : ''

    const combinedClassName = `card ${elevationClass} ${borderClass} ${roundedClass} ${paddedClass} ${clickableClass} ${className}`.trim()

    return (
        <div 
            className={combinedClassName}
            onClick={onClick}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    )
}